import React from 'react';

export default function DialLabel({ item, isActive, onClick }) {
  const isLeft = item.side === 'left';
  
  return (
    <div 
      className={`relative w-full flex items-center group cursor-pointer py-1 md:py-2 transition-all duration-300 ${isLeft ? 'justify-end' : 'justify-start'}`}
      onClick={onClick}
    >
      {/* Label Text */}
      <span 
        className={`
          text-sm md:text-lg font-medium tracking-wide z-10 transition-colors duration-300
          ${isActive ? 'text-red-700 font-bold drop-shadow-[0_0_8px_rgba(220,38,38,0.2)]' : 'text-gray-800 group-hover:text-gray-600'}
        `}
        style={{
          textShadow: isActive ? 'none' : '0px 1px 1px rgba(255,255,255,0.8)'
        }}
      >
        {item.title}
      </span>

      {/* Connecting Line (Simulated) */}
      <div 
        className={`absolute top-1/2 -translate-y-1/2 h-[1px] bg-gray-400 group-hover:bg-gray-500 transition-colors
          ${isLeft ? 'right-0 w-8 md:w-16 translate-x-full' : 'left-0 w-8 md:w-16 -translate-x-full'}
          ${isActive ? 'bg-red-400 h-[2px]' : ''}
        `}
        style={{
          boxShadow: '0 1px 0 rgba(255,255,255,0.6)'
        }}
      />
    </div>
  );
}